export type ChatLocationState = {
  resetAt?: number;
  initialQuery?: string;
  domainId?: number;
};

export function buildChatLaunchState(
  initialQuery: string,
  domainId: number,
): ChatLocationState {
  const trimmed = initialQuery.trim();
  return {
    resetAt: Date.now(),
    initialQuery: trimmed,
    domainId,
  };
}

export function readChatLocationState(
  state: unknown,
): ChatLocationState | null {
  if (state === null || typeof state !== "object") {
    return null;
  }
  const value = state as ChatLocationState;
  return {
    resetAt: typeof value.resetAt === "number" ? value.resetAt : undefined,
    initialQuery:
      typeof value.initialQuery === "string" ? value.initialQuery : undefined,
    domainId: typeof value.domainId === "number" ? value.domainId : undefined,
  };
}
